function getValueBySearch(arr: any[], value: string): any[] {
  return arr.filter(item => {
    const trimmedName = item.name.trim();
    const lowerCaseValue = value.toLowerCase().trim();

    if (trimmedName === '') {
      return false;
    }

    return trimmedName.toLowerCase().includes(lowerCaseValue);
  });
}

export { getValueBySearch };
